module.exports = __webpack_public_path__ + "img/icon_consent_s.5ad14fe2.svg";